import { createStore } from '@abyss/web/tools/createStore';

const useLoadingStore = createStore((set) => {
  return {
    loadingState: {
      loading: false,
      count: 0
    },
    setLoading: (loadingState) => {
      return set(() => {
        return { loadingState }
      });
    },
  };
});

export { useLoadingStore };
